import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Card, Col, Row, Spin, Table, Statistic, Badge,Space, Typography, Carousel } from "antd";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import {UserOutlined, ShoppingCartOutlined} from '@ant-design/icons'

const { Countdown } = Statistic;

class DashboardPage extends Component {
  constructor() {
    super();
    this.state = {
      statistics: {},
      during_diagnosis_repairs_count: 0,
      wait_to_confirm_count: 0,
      time_to_repair : 0,
      sliders: []
    };
  }

  async componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    // if (this.props.permissions.view) {
      await API.dashboard
        .list()
        .then(async (result) => {
          let during_diagnosis_repairs_count = 0
          let wait_to_confirm_count = 0

          let sliders = []
          result.sliders.map(slider => {
            sliders.push(Constants.baseUrl + "/" + slider.path)
          })
          this.setState({sliders: sliders})



          console.log("result.data : ",sliders)
          this.setState({time_to_repair : result.sumSecounds })
          await Promise.all(result.data.map(tempItem => {
            if(tempItem.status == "1" || tempItem.status == "2"){
              console.log("during_diagnosis_repairs_count")
              during_diagnosis_repairs_count += parseInt(tempItem.total)
            }
            if(tempItem.status == "3" || tempItem.status == "4"){
              wait_to_confirm_count += parseInt(tempItem.total)
            }
          }))
          console.log("during_diagnosis_repairs_count : ", during_diagnosis_repairs_count)
          this.setState({ loaded: true, 
            statistics: (result.data.length) ? result.data[0] : {} ,
            during_diagnosis_repairs_count : during_diagnosis_repairs_count,
            wait_to_confirm_count : wait_to_confirm_count
          
          });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    // }
  }



  render() {
    const { loaded, sliders, statistics, during_diagnosis_repairs_count, wait_to_confirm_count, time_to_repair } = this.state;
    const { permissions } = this.props;

    const boxStyle = "flex flex-row flex-shrink-0 max-w-3xl  bg-white shadow-lg rounded-xl px-5 py-3 flex flex-col items-center";


    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.dashboard}</Breadcrumb.Item>
        </Breadcrumb>
          <Row gutter={16} >
            <Col xs={24} sm={12} md={6}>


              <a href="/reception" >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <Badge.Ribbon text={(statistics.status == "0" ? statistics.total : 0) } color="pink">
                    <Card title={Resources.reception} size="small" className="dashborad_cart"></Card>
                  </Badge.Ribbon>
                </Space>
              </a>

            </Col>
            <Col xs={24} sm={12} md={6}>
              <a href="/repair_diagnostic" >
                  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <Badge.Ribbon text={during_diagnosis_repairs_count} color="pink">
                      <Card title={Resources.during_diagnosis_repairs} size="small" className="dashborad_cart"></Card>
                    </Badge.Ribbon>
                  </Space>
                </a>
            </Col>


            <Col xs={24} sm={12} md={6}>
                <a href="/wait_confirm" >
                  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <Badge.Ribbon text={wait_to_confirm_count } color="pink">
                      <Card title={Resources.wait_to_confirm} size="small" className="dashborad_cart"></Card>
                    </Badge.Ribbon>
                  </Space>
                </a>
            </Col>

            <Col xs={24} sm={12} md={6}>
                <a href="/be_confirm" >
                  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <Badge.Ribbon text={(statistics.status == "5" ? statistics.total : 0) } color="pink">
                      <Card title={Resources.be_confirm} size="small" className="dashborad_cart"></Card>
                    </Badge.Ribbon>
                  </Space>
                </a>
            </Col>

           
          </Row>

      <Row gutter={24} className="mt-3">
        <Col xs={24} sm={12} md={6}>

                <a href="/be_send" >
                  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <Badge.Ribbon text={(statistics.status == "6" ? statistics.total : 0) } color="pink">
                      <Card title={Resources.be_send} size="small" className="dashborad_cart"></Card>
                    </Badge.Ribbon>
                  </Space>
                </a>
            </Col>
          
      </Row>


          <Row gutter={24} className="mt-3">
          <div style={{ width: 800, margin: "50px auto" }}>
                  <Carousel autoplay dots>
                    {sliders.map((src, index) => (
                      <div key={index}>
                        <img
                          src={src}
                          alt={`slide-${index}`}
                          style={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      </div>
                    ))}
                  </Carousel>
                </div>
          </Row>

            <Row gutter={24} className="mt-3">
    
            <Col xs={24} sm={12} md={6}></Col>

               <Col  xs={24} sm={12} md={12} style={{backgroundColor: "#fff", textAlign:"center"}} >
             
              <h2 className="text-2xl font-bold text-gray-800 mb-4">⏳ زمان باقی‌مانده</h2>

              <div style={{display: "flex"}}>
                <div className={boxStyle}>
                    <span className="text-2xl font-bold text-indigo-600">{Math.floor(time_to_repair / (3600 * 24))}</span>
                    <span className="text-sm text-gray-500">روز</span>
                  </div>
                  <div className={boxStyle}>
                    <span className="text-2xl font-bold text-indigo-600">{Math.floor((time_to_repair % (3600 * 24)) / 3600)}</span>
                    <span className="text-sm text-gray-500">ساعت</span>
                  </div>
                  <div className={boxStyle}>
                    <span className="text-2xl font-bold text-indigo-600">{Math.floor((time_to_repair % 3600) / 60)}</span>
                    <span className="text-sm text-gray-500">دقیقه</span>
                  </div>
                  <div className={boxStyle}>
                    <span className="text-2xl font-bold text-indigo-600">{time_to_repair % 60}</span>
                    <span className="text-sm text-gray-500">ثانیه</span>
                  </div>
              </div>
                  
                
            </Col>
      </Row>
      </Fragment>



    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        view: CheckPermission(state.app.user, Permissions.dashboard_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(DashboardPage);
{/* <a href="/repair_diagnostic" >
                <div className="dashborad_cart"   >
                  <span className="dashborad_cart_title" >{Resources.during_diagnosis_repairs}</span>
                </div>
              </a> */}